<template>
  <div>
    <AdminUserTableDialog ref="adminUserDialog"></AdminUserTableDialog>
    <v-card>
      <p class="pt-3 pl-3 title">WeNews Users</p>
      <v-data-table
        :headers="headers"
        :items="userData"
        class="elevation-1"
        :search="search"
      >
        <template v-slot:top>
          <v-text-field v-model="search" label="Search userinfo here" class="mx-4" clearable></v-text-field>
        </template>
        <!--To see how many articles an user have written-->
        <template v-slot:item.articles="{ item }">
          <span> {{ item.articles.length }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
            medium
            @click="$refs.adminUserDialog.openDialog(item)"
            color="error"
          >
            fas fa-book
          </v-icon>
        </template>
        <!--Display a color based on how long its been since user were created-->
        <template v-slot:item.CreatedDays="{ item }">
          <v-chip :color="userAgeColor(item.CreatedDays)" dark>{{ item.CreatedDays }}</v-chip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
// Import store.js into the file
import { mapActions, mapGetters } from "vuex";
import AdminUserTableDialog from "@/pages/admin/components/users/dialog/adminUserTableDialog"
export default {
  components:{
    AdminUserTableDialog
  },
  data(){
    return{
      userData:[],
      search: '',
      headers:[
        { text: 'Id', value: 'id', align: 'left', width: "200px", fixed: true },
        { text: 'Nickname', value: 'Nickname', align: 'left', width: "200px", fixed: true },
        { text: 'Email', value: 'Email', align: 'center', width: "300px", fixed: true },
        { text: 'Articles', value: 'articles', align: 'center', width: "200px", fixed: true },
        { text: 'Country', value: 'Country', align: 'center', width: "200px", fixed: true },
        { text: 'Days created', value: 'CreatedDays', align: 'center', width: "200px", fixed: true },
        { text: 'User Development', value: 'actions', sortable: false, align: 'center', width: "200px", fixed: true }
      ]
    }
  },
  methods: {
    // The functions we wish to get from store.js
    ...mapActions([
      "GET_ALL_USER_DATA", "GET_ALL_ARTICLES"
    ]),
    // Get the data from this call
    getAllUserData() {
      this.GET_ALL_USER_DATA().then(response => {
        response = response.map(el => {
          return {
            ...el,
           CreatedDays: this.$moment().diff(this.$moment(el.Created), 'days'),
          }
        })
        this.userData = response;
      });
    },
    /*
      To see how old the account are, by color

    */
    userAgeColor (age) {
      if (age > 400) return 'red'
      else if (age > 250) return 'pink'
      else if (age > 120) return 'orange'
      else if (age > 30) return 'blue'
      else return 'green'
    },
  },
  // When loading page, run the functions within mounted.
  mounted() {
    this.getAllUserData();
  }
}
</script>